export default "__VITE_ASSET__faa6dd1e__"